import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EscalationModel } from '../../components/escalation/escalation.model';
import { ENDPOINTS } from '../../enums/endpoints.enum';
import { getUuidV4 } from '../../utilities/generic-utilities';
import { OdataService } from '../odata/odata.service';
import { OdataEscalation } from '../../state/escalation/escalation-collection.state';
import { NotificationStateUtilities } from '../../state/utilities/notification-state-utlities';
import { NotificationIdState } from '../../state/utilities/notification-id.type';

@Injectable({
    providedIn: 'root',
})
export class OdataEscalationService {
    public constructor(private readonly odataService: OdataService) {}

    public saveEscalationStatus(escalation: EscalationModel): Observable<unknown> {
        return this.odataService.deepInsertRequest(
            escalation,
            ENDPOINTS.EscalationSet,
            `${escalation.notificationId.toString()}-${getUuidV4()}`,
        );
    }

    /**
     * Variant for NgRx effects — accepts the pre-serialised out model so action payloads remain serialisable.
     *
     * @param odataEscalation
     */
    public saveEscalationStatusOutModel(odataEscalation: OdataEscalation): Observable<unknown> {
        const notificationId: NotificationIdState = {
            frontId: odataEscalation.FrontId,
            qmNum: odataEscalation.NotificationNo,
            maNum: odataEscalation.TaskNumber,
        };
        return this.odataService.deepInsertOutModelRequest(
            odataEscalation,
            ENDPOINTS.EscalationSet,
            `${NotificationStateUtilities.notificationIdToString(notificationId)}-${getUuidV4()}`,
        );
    }
}
